import { Img } from "@chakra-ui/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Keyboard, Mousewheel, Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
export default function ImageSlider({ photos = [] }) {
  return (
    <div>
      <Swiper
        cssMode={true}
        navigation={true}
        loop={true}
        mousewheel={true}
        keyboard={true}
        modules={[Navigation, Mousewheel, Keyboard]}
        className="mySwiper"
        slidesPerView={1}
        spaceBetween={30}
      >
        {photos.map((photo) => (
          <SwiperSlide key={photo.key}>
            <Img
              src={photo.url}
              rounded="xl"
              objectFit="cover"
              h={{ base: 40, lg: 200 }}
              w="100%"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
